"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { sessions: null };
        GState.bind(this, ['user']);
    },
    onMount: function () {
        this.fetchSessions();
    },
    onJoinSession: function (type, provider, id) {
        window.Extensions.run(provider, {
            action: 'open:session',
            body: {
                type,
                id
            }
        });
    },
    fetchSessions: async function () {
        try {
            const {error, message, sessions, more} = await Request(this.state.more || '/livesession/list');
            if (error)
                throw new Error(message);
            this.state.sessions = sessions;
        } catch (error) {
            console.log('Error Fetching Sessions: ', error);
            this.state.sessions = [];
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/LiveSessions/Learner/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Header_Learner_template = require("../../../components/Header-Learner.marko"),
    Header_Learner_tag = marko_loadTag(Header_Learner_template),
    CategoryFilters_template = require("../../../components/CategoryFilters.marko"),
    CategoryFilters_tag = marko_loadTag(CategoryFilters_template),
    SortListControl_template = require("../../../../components/SortListControl/index.marko"),
    SortListControl_tag = marko_loadTag(SortListControl_template),
    DoSearch_template = require("../../../../components/DoSearch/index.marko"),
    DoSearch_tag = marko_loadTag(DoSearch_template),
    FilterPanel_template = require("../../../components/FilterPanel.marko"),
    FilterPanel_tag = marko_loadTag(FilterPanel_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Card_LiveSession_template = require("../../../components/Card-LiveSession.marko"),
    Card_LiveSession_tag = marko_loadTag(Card_LiveSession_template),
    Wrapper_template = require("../../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("6f8d9b"),
    marko_node0 = marko_createElement("div", {
        "class": "d-flex align-items-center"
      }, "3", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "w-100 text-center"
        }, null, null, 1)
        .e("img", {
            src: "/images/illustration/live-session.png",
            "class": "img-fluid",
            alt: "illustration"
          }, null, null, 0),
    marko_attrs0 = {
        "class": "content-body pb-4"
      },
    marko_attrs1 = {
        "class": "filters mt-2"
      },
    marko_node1 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "icons mx-1"
      },
    marko_attrs3 = {
        id: "live sessions-list",
        "class": "mt-1"
      },
    marko_attrs4 = {
        "class": "row m-0"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      class: "pl-5 pr-3",
      scroll: true,
      renderBody: function(out) {
        if (state.sessions == null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (!state.sessions.length) {
          Header_Learner_tag({
              intro: "Good day",
              concern: state.user.first_name + "!",
              assessment: {
                  icon: "bx bxs-smile",
                  subject: "You have no active live session"
                },
              ranking: {}
            }, out, __component, "2");

          out.n(marko_node0, component);
        } else {
          Header_Learner_tag({
              intro: "Good day",
              concern: state.user.first_name + "!",
              assessment: {
                  icon: "bx bxs-smile",
                  subject: "How many live sessions have you had this week?"
                },
              ranking: {}
            }, out, __component, "6");

          out.be("div", marko_attrs0, "7", component);

          out.be("section", marko_attrs1, "8", component);

          CategoryFilters_tag({
              target: "livesessions"
            }, out, __component, "9", [
            [
              "init",
              "onFilterByCategories",
              false
            ],
            [
              "change",
              "onFilterByCategories",
              false
            ]
          ]);

          out.n(marko_node1, component);

          out.be("div", marko_attrs2, "11", component);

          SortListControl_tag({}, out, __component, "12");

          DoSearch_tag({
              target: "livesession",
              class: "float-right"
            }, out, __component, "13");

          FilterPanel_tag({
              class: "float-right dropleft mr-1"
            }, out, __component, "14");

          out.ee();

          out.ee();

          out.be("section", marko_attrs3, "15", component);

          out.be("div", marko_attrs4, "16", component);

          marko_forOf(state.sessions, function(session, index) {
            Card_LiveSession_tag(session, out, __component, index, [
              [
                "join",
                "onJoinSession",
                false
              ]
            ]);
          });

          out.ee();

          out.ee();

          out.ee();
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
